export const PAGINATION_KEY = 'pagination';

const save = (key: string, value: string | number): void => {
  window.sessionStorage.setItem(key, value as string);
};

const load = (key: string): Nullable<string> =>
  window.sessionStorage.getItem(key);

const clear = (key: string): void => {
  window.sessionStorage.removeItem(key);
};

export const savePaginateStorage = <T>(currPaginate: T): void => {
  save(PAGINATION_KEY, JSON.stringify(currPaginate));
};

export const loadPaginateStorage = <T>(): Nullable<T> => {
  return load(PAGINATION_KEY) ? JSON.parse(load(PAGINATION_KEY)!) : null;
};

export const clearPaginateStorage = () => {
  clear(PAGINATION_KEY);
};
